


































































































// utils helpers
import mixins from '@/utils/mixins';
import { AxiosError } from 'axios';

// mixins
import componentState from '@/mixins/state';

import { ALForm } from '@/common/component.types';
import { Agent } from '@/models/agent';
import { mapActions } from 'vuex';
import { cloneDeep } from 'lodash';
import { ErrorManager } from '@/models/error';

import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';

const MAX_CODE_LENGTH = 6;

const baseMixins = mixins(componentState);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'AgentFormDialog',

    components: { ALDialog, ErrorAlert },

    data: () => ({
      MAX_CODE_LENGTH,
      valid: false,
      dialog: false,
      loading: false,
      createForm: false,

      agent: new Agent(),
      codeRules: [
        (v: any) => !!v || 'Code is required',
        (v: any) =>
          (v && v.length <= MAX_CODE_LENGTH) ||
          `Code must be at most ${MAX_CODE_LENGTH} characters`
      ],
      regionRules: [(v: any) => !!v || 'Region is required'],
      nameRules: [(v: any) => !!v || 'Name is required'],

      errorMessage: '',
      detailErrorMessage: ''
    }),

    methods: {
      ...mapActions({
        updateAgent: 'agent/updateAgent',
        createAgent: 'agent/createAgent'
      }),

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
      },

      open(agent?: Agent) {
        try {
          if (agent) {
            this.agent = cloneDeep(agent);
            this.createForm = false;
          } else {
            this.createForm = true;
          }
          this.dialog = true;
          this.setComponentState('loaded');
          this.resetFormValidation();
        } catch (err) {
          this.setComponentState('error', err);
        }
      },

      async close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.agent = new Agent();
          this.createForm = false;
        });
      },

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      async save() {
        if (this.validateForm()) {
          this.loading = true;
          this.clearAllErrors();
          try {
            if (this.createForm) {
              await this.createAgent(this.agent);
            } else {
              await this.updateAgent(this.agent);
            }
            this.close();
          } catch (err) {
            const error = err as AxiosError;
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          } finally {
            this.loading = false;
          }
        }
      }
    }
  });
